const adfStreamStartingWrappers = ['```json', '<adf_input>'];
const adfStreamEndingWrappers = ['```', '</adf_input>'];
/**
 * Removes known wrapper strings that sometimes surround ADF JSON content generated by LLM models.
 * These wrappers make the content invalid JSON, preventing parsing by ADFStreamer.
 *
 * @param {string} content - The content to sanitize.
 * @returns The sanitized content with wrapper strings removed.
 * @example
 * sanitizeStreamContentForADFStreamer('```json{"type":"doc"}</adf_input>');
 * // returns '{"type":"doc"}'
 */
export function sanitizeStreamContentForADFStreamer(content: string): string {
	adfStreamStartingWrappers.forEach((wrapper) => {
		if (content.startsWith(wrapper)) {
			content = content.replace(wrapper, '');
		}
	});
	adfStreamEndingWrappers.forEach((wrapper) => {
		if (content.endsWith(wrapper)) {
			content = content.replace(wrapper, '');
		}
	});
	return content;
}
